import { Component } from '@angular/core';

@Component({
  selector: 'app-dialog-device-details',
  templateUrl: './dialog-device-details.component.html',
  styleUrls: ['./dialog-device-details.component.scss']
})
export class DialogDeviceDetailsComponent {

}
